import styled from "styled-components";
 

export const MessageWindowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2em 4em;
  flex-direction: column;
  gap: 1em;
 
  margin: 0 auto;

 

  .message-content {
    font-size: 1.1em;
    
    font-weight: 500;

   &::first-letter {
      text-transform: capitalize;
    }
  }
`